<div class="upsell-header py-5 bg-bhmd-blue">
  <div class="upsell-header__container text-white mx-auto p-4 text-center desktop:text-left flex flex-col items-center gap-8 desktop:flex-row justify-between"> 
    <img class="upsell-header__logo max-w-sm desktop:max-w-xs mx-auto px-8 desktop:px-0" [src]="icon" alt="Beverly Hills MD">
    <div class="upsell-header__text"> 
      <div class="text-3xl"><span class="font-semibold">WAIT</span>... YOUR ORDER IS NOT COMPLETE!</div>
      <div>Do not hit the "back" button, it can cause multiple charges on your card</div>
    </div>
  </div>
</div>
